<template>
  <trid-rotation v-if="valueName == '3d_rotation'" />
  <accessibility v-else-if="valueName == 'accessibility'" />
  <accessibility-new v-else-if="valueName == 'accessibility_new'" />
  <accessible v-else-if="valueName == 'accessible'" />
  <accessible-forward v-else-if="valueName == 'accessible_forward'" />
  <account-balance v-else-if="valueName == 'account_balance'" />
  <account-balance-wallet v-else-if="valueName == 'account_balance_wallet'" />
  <account-box v-else-if="valueName == 'account_box'" />
  <account-circle v-else-if="valueName == 'account_circle'" />
  <add-shopping-cart v-else-if="valueName == 'add_shopping_cart'" />
  <add-task v-else-if="valueName == 'add_task'" />
  <addchart v-else-if="valueName == 'addchart'" />
  <admin-panel-settings v-else-if="valueName == 'admin_panel_settings'" />
  <alarm v-else-if="valueName == 'alarm'" />
  <alarm-add v-else-if="valueName == 'alarm_add'" />
  <alarm-off v-else-if="valueName == 'alarm_off'" />
  <alarm-on v-else-if="valueName == 'alarm_on'" />
  <all-inbox v-else-if="valueName == 'all_inbox'" />
  <all-out v-else-if="valueName == 'all_out'" />
  <analytics v-else-if="valueName == 'analytics'" />
  <anchor v-else-if="valueName == 'anchor'" />
  <android v-else-if="valueName == 'android'" />
  <announcement v-else-if="valueName == 'announcement'" />
  <api v-else-if="valueName == 'api'" />
  <app-blocking v-else-if="valueName == 'app_blocking'" />
  <arrow-circle-down v-else-if="valueName == 'arrow_circle_down'" />
  <arrow-circle-up v-else-if="valueName == 'arrow_circle_up'" />
  <arrow-right-alt v-else-if="valueName == 'arrow_right_alt'" />
  <ic-article v-else-if="valueName == 'article'" />
  <aspect-ratio v-else-if="valueName == 'aspect_ratio'" />
  <assessment v-else-if="valueName == 'assessment'" />
  <assignment v-else-if="valueName == 'assignment'" />
  <assignment-ind v-else-if="valueName == 'assignment_ind'" />
  <assignment-late v-else-if="valueName == 'assignment_late'" />
  <assignment-return v-else-if="valueName == 'assignment_return'" />
  <assignment-returned v-else-if="valueName == 'assignment_returned'" />
  <assignment-turned-in v-else-if="valueName == 'assignment_turned_in'" />
  <autorenew v-else-if="valueName == 'autorenew'" />
  <backup v-else-if="valueName == 'backup'" />
  <backup-table v-else-if="valueName == 'backup_table'" />
  <batch-prediction v-else-if="valueName == 'batch_prediction'" />
  <book v-else-if="valueName == 'book'" />
  <book-online v-else-if="valueName == 'book_online'" />
  <bookmark v-else-if="valueName == 'bookmark'" />
  <bookmark-border v-else-if="valueName == 'bookmark_border'" />
  <bookmarks v-else-if="valueName == 'bookmarks'" />
  <bug-report v-else-if="valueName == 'bug_report'" />
  <build v-else-if="valueName == 'build'" />
  <build-circle v-else-if="valueName == 'build_circle'" />
  <cached v-else-if="valueName == 'cached'" />
  <calendar-today v-else-if="valueName == 'calendar_today'" />
  <calendar-view-day v-else-if="valueName == 'calendar_view_day'" />
  <camera-enhance v-else-if="valueName == 'camera_enhance'" />
  <cancel-schedule-send v-else-if="valueName == 'cancel_schedule_send'" />
  <card-giftcard v-else-if="valueName == 'card_giftcard'" />
  <card-membership v-else-if="valueName == 'card_membership'" />
  <card-travel v-else-if="valueName == 'card_travel'" />
  <change-history v-else-if="valueName == 'change_history'" />
  <check-circle v-else-if="valueName == 'check_circle'" />
  <check-circle-outline v-else-if="valueName == 'check_circle_outline'" />
  <chrome-reader-mode v-else-if="valueName == 'chrome_reader_mode'" />
  <class v-else-if="valueName == 'class'" />
  <close-fullscreen v-else-if="valueName == 'close_fullscreen'" />
  <ic-code v-else-if="valueName == 'code'" />
  <comment-bank v-else-if="valueName == 'comment_bank'" />
  <commute v-else-if="valueName == 'commute'" />
  <compare-arrows v-else-if="valueName == 'compare_arrows'" />
  <contact-page v-else-if="valueName == 'contact_page'" />
  <contact-support v-else-if="valueName == 'contact_support'" />
  <contactless v-else-if="valueName == 'contactless'" />
  <copyright v-else-if="valueName == 'copyright'" />
  <credit-card v-else-if="valueName == 'credit_card'" />
  <dashboard v-else-if="valueName == 'dashboard'" />
  <date-range v-else-if="valueName == 'date_range'" />
  <delete v-else-if="valueName == 'delete'" />
  <delete-forever v-else-if="valueName == 'delete_forever'" />
  <delete-outline v-else-if="valueName == 'delete_outline'" />
  <description v-else-if="valueName == 'description'" />
  <disabled-by-default v-else-if="valueName == 'disabled_by_default'" />
  <dns v-else-if="valueName == 'dns'" />
  <done v-else-if="valueName == 'done'" />
  <done-all v-else-if="valueName == 'done_all'" />
  <done-outline v-else-if="valueName == 'done_outline'" />
  <donut-large v-else-if="valueName == 'donut_large'" />
  <donut-small v-else-if="valueName == 'donut_small'" />
  <drag-indicator v-else-if="valueName == 'drag_indicator'" />
  <dynamic-form v-else-if="valueName == 'dynamic_form'" />
  <eco v-else-if="valueName == 'eco'" />
  <eject v-else-if="valueName == 'eject'" />
  <euro-symbol v-else-if="valueName == 'euro_symbol'" />
  <event v-else-if="valueName == 'event'" />
  <event-seat v-else-if="valueName == 'event_seat'" />
  <exit-to-app v-else-if="valueName == 'exit_to_app'" />
  <explore v-else-if="valueName == 'explore'" />
  <explore-off v-else-if="valueName == 'explore_off'" />
  <extension v-else-if="valueName == 'extension'" />
  <face v-else-if="valueName == 'face'" />
  <face-unlock v-else-if="valueName == 'face_unlock'" />
  <fact-check v-else-if="valueName == 'fact_check'" />
  <favorite v-else-if="valueName == 'favorite'" />
  <favorite-border v-else-if="valueName == 'favorite_border'" />
  <feedback v-else-if="valueName == 'feedback'" />
  <filter-alt v-else-if="valueName == 'filter_alt'" />
  <find-in-page v-else-if="valueName == 'find_in_page'" />
  <find-replace v-else-if="valueName == 'find_replace'" />
  <fingerprint v-else-if="valueName == 'fingerprint'" />
  <flaky v-else-if="valueName == 'flaky'" />
  <flight-land v-else-if="valueName == 'flight_land'" />
  <flight-takeoff v-else-if="valueName == 'flight_takeoff'" />
  <flip-to-back v-else-if="valueName == 'flip_to_back'" />
  <flip-to-front v-else-if="valueName == 'flip_to_front'" />
  <g-translate v-else-if="valueName == 'g_translate'" />
  <gavel v-else-if="valueName == 'gavel'" />
  <get-app v-else-if="valueName == 'get_app'" />
  <gif v-else-if="valueName == 'gif'" />
  <grade v-else-if="valueName == 'grade'" />
  <grading v-else-if="valueName == 'grading'" />
  <group-work v-else-if="valueName == 'group_work'" />
  <help v-else-if="valueName == 'help'" />
  <help-center v-else-if="valueName == 'help_center'" />
  <help-outline v-else-if="valueName == 'help_outline'" />
  <highlight-alt v-else-if="valueName == 'highlight_alt'" />
  <highlight-off v-else-if="valueName == 'highlight_off'" />
  <history v-else-if="valueName == 'history'" />
  <history-toggle-off v-else-if="valueName == 'history_toggle_off'" />
  <home v-else-if="valueName == 'home'" />
  <horizontal-split v-else-if="valueName == 'horizontal_split'" />
  <hourglass-disabled v-else-if="valueName == 'hourglass_disabled'" />
  <hourglass-empty v-else-if="valueName == 'hourglass_empty'" />
  <hourglass-full v-else-if="valueName == 'hourglass_full'" />
  <http v-else-if="valueName == 'http'" />
  <https v-else-if="valueName == 'https'" />
  <important-devices v-else-if="valueName == 'important_devices'" />
  <info v-else-if="valueName == 'info'" />
  <info-outline v-else-if="valueName == 'info_outline'" />
  <ic-input v-else-if="valueName == 'input'" />
  <integration-instructions
    v-else-if="valueName == 'integration_instructions'"
  />
  <invert-colors v-else-if="valueName == 'invert_colors'" />
  <ic-label v-else-if="valueName == 'label'" />
  <label-important v-else-if="valueName == 'label_important'" />
  <label-important-outline v-else-if="valueName == 'label_important_outline'" />
  <label-off v-else-if="valueName == 'label_off'" />
  <label-outline v-else-if="valueName == 'label_outline'" />
  <language v-else-if="valueName == 'language'" />
  <launch v-else-if="valueName == 'launch'" />
  <leaderboard v-else-if="valueName == 'leaderboard'" />
  <lightbulb-outline v-else-if="valueName == 'lightbulb_outline'" />
  <line-style v-else-if="valueName == 'line_style'" />
  <line-weight v-else-if="valueName == 'line_weight'" />
  <list v-else-if="valueName == 'list'" />
  <lock v-else-if="valueName == 'lock'" />
  <lock-open v-else-if="valueName == 'lock_open'" />
  <lock-outline v-else-if="valueName == 'lock_outline'" />
  <login v-else-if="valueName == 'login'" />
  <loyalty v-else-if="valueName == 'loyalty'" />
  <markunread-mailbox v-else-if="valueName == 'markunread_mailbox'" />
  <maximize v-else-if="valueName == 'maximize'" />
  <mediation v-else-if="valueName == 'mediation'" />
  <minimize v-else-if="valueName == 'minimize'" />
  <model-training v-else-if="valueName == 'model_training'" />
  <next-plan v-else-if="valueName == 'next_plan'" />
  <not-accessible v-else-if="valueName == 'not_accessible'" />
  <not-started v-else-if="valueName == 'not_started'" />
  <note-add v-else-if="valueName == 'note_add'" />
  <offline-bolt v-else-if="valueName == 'offline_bolt'" />
  <offline-pin v-else-if="valueName == 'offline_pin'" />
  <online-prediction v-else-if="valueName == 'online_prediction'" />
  <opacity v-else-if="valueName == 'opacity'" />
  <open-in-browser v-else-if="valueName == 'open_in_browser'" />
  <open-in-full v-else-if="valueName == 'open_in_full'" />
  <open-in-new v-else-if="valueName == 'open_in_new'" />
  <open-with v-else-if="valueName == 'open_with'" />
  <outbond v-else-if="valueName == 'outbond'" />
  <outlet v-else-if="valueName == 'outlet'" />
  <pageview v-else-if="valueName == 'pageview'" />
  <pan-tool v-else-if="valueName == 'pan_tool'" />
  <payment v-else-if="valueName == 'payment'" />
  <pending v-else-if="valueName == 'pending'" />
  <pending-actions v-else-if="valueName == 'pending_actions'" />
  <perm-camera-mic v-else-if="valueName == 'perm_camera_mic'" />
  <perm-contact-calendar v-else-if="valueName == 'perm_contact_calendar'" />
  <perm-data-setting v-else-if="valueName == 'perm_data_setting'" />
  <perm-device-information v-else-if="valueName == 'perm_device_information'" />
  <perm-identity v-else-if="valueName == 'perm_identity'" />
  <perm-media v-else-if="valueName == 'perm_media'" />
  <perm-phone-msg v-else-if="valueName == 'perm_phone_msg'" />
  <perm-scan-wifi v-else-if="valueName == 'perm_scan_wifi'" />
  <pets v-else-if="valueName == 'pets'" />
  <picture-in-picture v-else-if="valueName == 'picture_in_picture'" />
  <picture-in-picture-alt v-else-if="valueName == 'picture_in_picture_alt'" />
  <plagiarism v-else-if="valueName == 'plagiarism'" />
  <play-for-work v-else-if="valueName == 'play_for_work'" />
  <polymer v-else-if="valueName == 'polymer'" />
  <power-settings-new v-else-if="valueName == 'power_settings_new'" />
  <pregnant-woman v-else-if="valueName == 'pregnant_woman'" />
  <preview v-else-if="valueName == 'preview'" />
  <print v-else-if="valueName == 'print'" />
  <privacy-tip v-else-if="valueName == 'privacy_tip'" />
  <published-with-changes v-else-if="valueName == 'published_with_changes'" />
  <query-builder v-else-if="valueName == 'query_builder'" />
  <question-answer v-else-if="valueName == 'question_answer'" />
  <quickreply v-else-if="valueName == 'quickreply'" />
  <receipt v-else-if="valueName == 'receipt'" />
  <record-voice-over v-else-if="valueName == 'record_voice_over'" />
  <redeem v-else-if="valueName == 'redeem'" />
  <remove-shopping-cart v-else-if="valueName == 'remove_shopping_cart'" />
  <reorder v-else-if="valueName == 'reorder'" />
  <report-problem v-else-if="valueName == 'report_problem'" />
  <request-page v-else-if="valueName == 'request_page'" />
  <restore v-else-if="valueName == 'restore'" />
  <restore-from-trash v-else-if="valueName == 'restore_from_trash'" />
  <restore-page v-else-if="valueName == 'restore_page'" />
  <room v-else-if="valueName == 'room'" />
  <rounded-corner v-else-if="valueName == 'rounded_corner'" />
  <rowing v-else-if="valueName == 'rowing'" />
  <rule v-else-if="valueName == 'rule'" />
  <schedule v-else-if="valueName == 'schedule'" />
  <search v-else-if="valueName == 'search'" />
  <search-off v-else-if="valueName == 'search_off'" />
  <settings v-else-if="valueName == 'settings'" />
  <settings-applications v-else-if="valueName == 'settings_applications'" />
  <settings-backup-restore v-else-if="valueName == 'settings_backup_restore'" />
  <settings-bluetooth v-else-if="valueName == 'settings_bluetooth'" />
  <settings-brightness v-else-if="valueName == 'settings_brightness'" />
  <settings-cell v-else-if="valueName == 'settings_cell'" />
  <settings-ethernet v-else-if="valueName == 'settings_ethernet'" />
  <settings-input-antenna v-else-if="valueName == 'settings_input_antenna'" />
  <settings-input-component
    v-else-if="valueName == 'settings_input_component'"
  />
  <settings-input-composite
    v-else-if="valueName == 'settings_input_composite'"
  />
  <settings-input-hdmi v-else-if="valueName == 'settings_input_hdmi'" />
  <settings-input-svideo v-else-if="valueName == 'settings_input_svideo'" />
  <settings-overscan v-else-if="valueName == 'settings_overscan'" />
  <settings-phone v-else-if="valueName == 'settings_phone'" />
  <settings-power v-else-if="valueName == 'settings_power'" />
  <settings-remote v-else-if="valueName == 'settings_remote'" />
  <settings-voice v-else-if="valueName == 'settings_voice'" />
  <shop v-else-if="valueName == 'shop'" />
  <shop-two v-else-if="valueName == 'shop_two'" />
  <shopping-bag v-else-if="valueName == 'shopping_bag'" />
  <shopping-basket v-else-if="valueName == 'shopping_basket'" />
  <shopping-cart v-else-if="valueName == 'shopping_cart'" />
  <smart-button v-else-if="valueName == 'smart_button'" />
  <ic-source v-else-if="valueName == 'source'" />
  <speaker-notes v-else-if="valueName == 'speaker_notes'" />
  <speaker-notes-off v-else-if="valueName == 'speaker_notes_off'" />
  <spellcheck v-else-if="valueName == 'spellcheck'" />
  <star-rate v-else-if="valueName == 'star_rate'" />
  <stars v-else-if="valueName == 'stars'" />
  <sticky-note-2 v-else-if="valueName == 'sticky_note_2'" />
  <store v-else-if="valueName == 'store'" />
  <subject v-else-if="valueName == 'subject'" />
  <subtitles-off v-else-if="valueName == 'subtitles_off'" />
  <supervised-user-circle v-else-if="valueName == 'supervised_user_circle'" />
  <supervisor-account v-else-if="valueName == 'supervisor_account'" />
  <support v-else-if="valueName == 'support'" />
  <swap-horiz v-else-if="valueName == 'swap_horiz'" />
  <swap-horizontal-circle v-else-if="valueName == 'swap_horizontal_circle'" />
  <swap-vert v-else-if="valueName == 'swap_vert'" />
  <swap-vertical-circle v-else-if="valueName == 'swap_vertical_circle'" />
  <sync-alt v-else-if="valueName == 'sync_alt'" />
  <system-update-alt v-else-if="valueName == 'system_update_alt'" />
  <tab v-else-if="valueName == 'tab'" />
  <tab-unselected v-else-if="valueName == 'tab_unselected'" />
  <table-view v-else-if="valueName == 'table_view'" />
  <text-rotate-up v-else-if="valueName == 'text_rotate_up'" />
  <text-rotate-vertical v-else-if="valueName == 'text_rotate_vertical'" />
  <text-rotation-angledown v-else-if="valueName == 'text_rotation_angledown'" />
  <text-rotation-angleup v-else-if="valueName == 'text_rotation_angleup'" />
  <text-rotation-down v-else-if="valueName == 'text_rotation_down'" />
  <text-rotation-none v-else-if="valueName == 'text_rotation_none'" />
  <theaters v-else-if="valueName == 'theaters'" />
  <thumb-down v-else-if="valueName == 'thumb_down'" />
  <thumb-up v-else-if="valueName == 'thumb_up'" />
  <thumbs-up-down v-else-if="valueName == 'thumbs_up_down'" />
  <timeline v-else-if="valueName == 'timeline'" />
  <toc v-else-if="valueName == 'toc'" />
  <today v-else-if="valueName == 'today'" />
  <toll v-else-if="valueName == 'toll'" />
  <touch-app v-else-if="valueName == 'touch_app'" />
  <tour v-else-if="valueName == 'tour'" />
  <track-changes v-else-if="valueName == 'track_changes'" />
  <translate v-else-if="valueName == 'translate'" />
  <trending-down v-else-if="valueName == 'trending_down'" />
  <trending-flat v-else-if="valueName == 'trending_flat'" />
  <trending-up v-else-if="valueName == 'trending_up'" />
  <turned-in v-else-if="valueName == 'turned_in'" />
  <turned-in-not v-else-if="valueName == 'turned_in_not'" />
  <unpublished v-else-if="valueName == 'unpublished'" />
  <update v-else-if="valueName == 'update'" />
  <upgrade v-else-if="valueName == 'upgrade'" />
  <verified v-else-if="valueName == 'verified'" />
  <verified-user v-else-if="valueName == 'verified_user'" />
  <vertical-split v-else-if="valueName == 'vertical_split'" />
  <view-agenda v-else-if="valueName == 'view_agenda'" />
  <view-array v-else-if="valueName == 'view_array'" />
  <view-carousel v-else-if="valueName == 'view_carousel'" />
  <view-column v-else-if="valueName == 'view_column'" />
  <view-day v-else-if="valueName == 'view_day'" />
  <view-headline v-else-if="valueName == 'view_headline'" />
  <view-list v-else-if="valueName == 'view_list'" />
  <view-module v-else-if="valueName == 'view_module'" />
  <view-quilt v-else-if="valueName == 'view_quilt'" />
  <view-sidebar v-else-if="valueName == 'view_sidebar'" />
  <view-stream v-else-if="valueName == 'view_stream'" />
  <view-week v-else-if="valueName == 'view_week'" />
  <visibility v-else-if="valueName == 'visibility'" />
  <visibility-off v-else-if="valueName == 'visibility_off'" />
  <voice-over-off v-else-if="valueName == 'voice_over_off'" />
  <watch-later v-else-if="valueName == 'watch_later'" />
  <wifi-protected-setup v-else-if="valueName == 'wifi_protected_setup'" />
  <work v-else-if="valueName == 'work'" />
  <work-off v-else-if="valueName == 'work_off'" />
  <work-outline v-else-if="valueName == 'work_outline'" />
  <wysiwyg v-else-if="valueName == 'wysiwyg'" />
  <youtube-searched-for v-else-if="valueName == 'youtube_searched_for'" />
  <zoom-in v-else-if="valueName == 'zoom_in'" />
  <zoom-out v-else-if="valueName == 'zoom_out'" />
  <home-linear v-else-if="valueName == 'home_linear'" />
  <logout v-else-if="valueName == 'logout'" />
  <home-bold v-else-if="valueName == 'home_bold'" />
</template>

<script>
import TridRotation from "@/components/Icons/Action/TridRotation";
import Accessibility from "@/components/Icons/Action/Accessibility";
import AccessibilityNew from "@/components/Icons/Action/AccessibilityNew";
import Accessible from "@/components/Icons/Action/Accessible";
import AccessibleForward from "@/components/Icons/Action/AccessibleForward";
import AccountBalance from "@/components/Icons/Action/AccountBalance";
import AccountBalanceWallet from "@/components/Icons/Action/AccountBalanceWallet";
import AccountBox from "@/components/Icons/Action/AccountBox";
import AccountCircle from "@/components/Icons/Action/AccountCircle";
import AddShoppingCart from "@/components/Icons/Action/AddShoppingCart";
import AddTask from "@/components/Icons/Action/AddTask";
import Addchart from "@/components/Icons/Action/Addchart";
import AdminPanelSettings from "@/components/Icons/Action/AdminPanelSettings";
import Alarm from "@/components/Icons/Action/Alarm";
import AlarmAdd from "@/components/Icons/Action/AlarmAdd";
import AlarmOff from "@/components/Icons/Action/AlarmOff";
import AlarmOn from "@/components/Icons/Action/AlarmOn";
import AllInbox from "@/components/Icons/Action/AllInbox";
import AllOut from "@/components/Icons/Action/AllOut";
import Analytics from "@/components/Icons/Action/Analytics";
import Anchor from "@/components/Icons/Action/Anchor";
import Android from "@/components/Icons/Action/Android";
import Announcement from "@/components/Icons/Action/Announcement";
import Api from "@/components/Icons/Action/Api";
import AppBlocking from "@/components/Icons/Action/AppBlocking";
import ArrowCircleDown from "@/components/Icons/Action/ArrowCircleDown";
import ArrowCircleUp from "@/components/Icons/Action/ArrowCircleUp";
import ArrowRightAlt from "@/components/Icons/Action/ArrowRightAlt";
import IcArticle from "@/components/Icons/Action/IcArticle";
import AspectRatio from "@/components/Icons/Action/AspectRatio";
import Assessment from "@/components/Icons/Action/Assessment";
import Assignment from "@/components/Icons/Action/Assignment";
import AssignmentInd from "@/components/Icons/Action/AssignmentInd";
import AssignmentLate from "@/components/Icons/Action/AssignmentLate";
import AssignmentReturn from "@/components/Icons/Action/AssignmentReturn";
import AssignmentReturned from "@/components/Icons/Action/AssignmentReturned";
import AssignmentTurnedIn from "@/components/Icons/Action/AssignmentTurnedIn";
import Autorenew from "@/components/Icons/Action/Autorenew";
import Backup from "@/components/Icons/Action/Backup";
import BackupTable from "@/components/Icons/Action/BackupTable";
import BatchPrediction from "@/components/Icons/Action/BatchPrediction";
import Book from "@/components/Icons/Action/Book";
import BookOnline from "@/components/Icons/Action/BookOnline";
import Bookmark from "@/components/Icons/Action/Bookmark";
import BookmarkBorder from "@/components/Icons/Action/BookmarkBorder";
import Bookmarks from "@/components/Icons/Action/Bookmarks";
import BugReport from "@/components/Icons/Action/BugReport";
import Build from "@/components/Icons/Action/Build";
import BuildCircle from "@/components/Icons/Action/BuildCircle";
import Cached from "@/components/Icons/Action/Cached";
import CalendarToday from "@/components/Icons/Action/CalendarToday";
import CalendarViewDay from "@/components/Icons/Action/CalendarViewDay";
import CameraEnhance from "@/components/Icons/Action/CameraEnhance";
import CancelScheduleSend from "@/components/Icons/Action/CancelScheduleSend";
import CardGiftcard from "@/components/Icons/Action/CardGiftcard";
import CardMembership from "@/components/Icons/Action/CardMembership";
import CardTravel from "@/components/Icons/Action/CardTravel";
import ChangeHistory from "@/components/Icons/Action/ChangeHistory";
import CheckCircle from "@/components/Icons/Action/CheckCircle";
import CheckCircleOutline from "@/components/Icons/Action/CheckCircleOutline";
import ChromeReaderMode from "@/components/Icons/Action/ChromeReaderMode";
import Class from "@/components/Icons/Action/Class";
import CloseFullscreen from "@/components/Icons/Action/CloseFullscreen";
import IcCode from "@/components/Icons/Action/IcCode";
import CommentBank from "@/components/Icons/Action/CommentBank";
import Commute from "@/components/Icons/Action/Commute";
import CompareArrows from "@/components/Icons/Action/CompareArrows";
import ContactPage from "@/components/Icons/Action/ContactPage";
import ContactSupport from "@/components/Icons/Action/ContactSupport";
import Contactless from "@/components/Icons/Action/Contactless";
import Copyright from "@/components/Icons/Action/Copyright";
import CreditCard from "@/components/Icons/Action/CreditCard";
import Dashboard from "@/components/Icons/Action/Dashboard";
import DateRange from "@/components/Icons/Action/DateRange";
import Delete from "@/components/Icons/Action/Delete";
import DeleteForever from "@/components/Icons/Action/DeleteForever";
import DeleteOutline from "@/components/Icons/Action/DeleteOutline";
import Description from "@/components/Icons/Action/Description";
import DisabledByDefault from "@/components/Icons/Action/DisabledByDefault";
import Dns from "@/components/Icons/Action/Dns";
import Done from "@/components/Icons/Action/Done";
import DoneAll from "@/components/Icons/Action/DoneAll";
import DoneOutline from "@/components/Icons/Action/DoneOutline";
import DonutLarge from "@/components/Icons/Action/DonutLarge";
import DonutSmall from "@/components/Icons/Action/DonutSmall";
import DragIndicator from "@/components/Icons/Action/DragIndicator";
import DynamicForm from "@/components/Icons/Action/DynamicForm";
import Eco from "@/components/Icons/Action/Eco";
import Eject from "@/components/Icons/Action/Eject";
import EuroSymbol from "@/components/Icons/Action/EuroSymbol";
import Event from "@/components/Icons/Action/Event";
import EventSeat from "@/components/Icons/Action/EventSeat";
import ExitToApp from "@/components/Icons/Action/ExitToApp";
import Explore from "@/components/Icons/Action/Explore";
import ExploreOff from "@/components/Icons/Action/ExploreOff";
import Extension from "@/components/Icons/Action/Extension";
import Face from "@/components/Icons/Action/Face";
import FaceUnlock from "@/components/Icons/Action/FaceUnlock";
import FactCheck from "@/components/Icons/Action/FactCheck";
import Favorite from "@/components/Icons/Action/Favorite";
import FavoriteBorder from "@/components/Icons/Action/FavoriteBorder";
import Feedback from "@/components/Icons/Action/Feedback";
import FilterAlt from "@/components/Icons/Action/FilterAlt";
import FindInPage from "@/components/Icons/Action/FindInPage";
import FindReplace from "@/components/Icons/Action/FindReplace";
import Fingerprint from "@/components/Icons/Action/Fingerprint";
import Flaky from "@/components/Icons/Action/Flaky";
import FlightLand from "@/components/Icons/Action/FlightLand";
import FlightTakeoff from "@/components/Icons/Action/FlightTakeoff";
import FlipToBack from "@/components/Icons/Action/FlipToBack";
import FlipToFront from "@/components/Icons/Action/FlipToFront";
import GTranslate from "@/components/Icons/Action/GTranslate";
import Gavel from "@/components/Icons/Action/Gavel";
import GetApp from "@/components/Icons/Action/GetApp";
import Gif from "@/components/Icons/Action/Gif";
import Grade from "@/components/Icons/Action/Grade";
import Grading from "@/components/Icons/Action/Grading";
import GroupWork from "@/components/Icons/Action/GroupWork";
import Help from "@/components/Icons/Action/Help";
import HelpCenter from "@/components/Icons/Action/HelpCenter";
import HelpOutline from "@/components/Icons/Action/HelpOutline";
import HighlightAlt from "@/components/Icons/Action/HighlightAlt";
import HighlightOff from "@/components/Icons/Action/HighlightOff";
import History from "@/components/Icons/Action/History";
import HistoryToggleOff from "@/components/Icons/Action/HistoryToggleOff";
import Home from "@/components/Icons/Action/Home";
import HorizontalSplit from "@/components/Icons/Action/HorizontalSplit";
import HourglassDisabled from "@/components/Icons/Action/HourglassDisabled";
import HourglassEmpty from "@/components/Icons/Action/HourglassEmpty";
import HourglassFull from "@/components/Icons/Action/HourglassFull";
import Http from "@/components/Icons/Action/Http";
import Https from "@/components/Icons/Action/Https";
import ImportantDevices from "@/components/Icons/Action/ImportantDevices";
import Info from "@/components/Icons/Action/Info";
import InfoOutline from "@/components/Icons/Action/InfoOutline";
import IcInput from "@/components/Icons/Action/IcInput";
import IntegrationInstructions from "@/components/Icons/Action/IntegrationInstructions";
import InvertColors from "@/components/Icons/Action/InvertColors";
import IcLabel from "@/components/Icons/Action/IcLabel";
import LabelImportant from "@/components/Icons/Action/LabelImportant";
import LabelImportantOutline from "@/components/Icons/Action/LabelImportantOutline";
import LabelOff from "@/components/Icons/Action/LabelOff";
import LabelOutline from "@/components/Icons/Action/LabelOutline";
import Language from "@/components/Icons/Action/Language";
import Launch from "@/components/Icons/Action/Launch";
import Leaderboard from "@/components/Icons/Action/Leaderboard";
import LightbulbOutline from "@/components/Icons/Action/LightbulbOutline";
import LineStyle from "@/components/Icons/Action/LineStyle";
import LineWeight from "@/components/Icons/Action/LineWeight";
import List from "@/components/Icons/Action/List";
import Lock from "@/components/Icons/Action/Lock";
import LockOpen from "@/components/Icons/Action/LockOpen";
import LockOutline from "@/components/Icons/Action/LockOutline";
import Login from "@/components/Icons/Action/Login";
import Loyalty from "@/components/Icons/Action/Loyalty";
import MarkunreadMailbox from "@/components/Icons/Action/MarkunreadMailbox";
import Maximize from "@/components/Icons/Action/Maximize";
import Mediation from "@/components/Icons/Action/Mediation";
import Minimize from "@/components/Icons/Action/Minimize";
import ModelTraining from "@/components/Icons/Action/ModelTraining";
import NextPlan from "@/components/Icons/Action/NextPlan";
import NotAccessible from "@/components/Icons/Action/NotAccessible";
import NotStarted from "@/components/Icons/Action/NotStarted";
import NoteAdd from "@/components/Icons/Action/NoteAdd";
import OfflineBolt from "@/components/Icons/Action/OfflineBolt";
import OfflinePin from "@/components/Icons/Action/OfflinePin";
import OnlinePrediction from "@/components/Icons/Action/OnlinePrediction";
import Opacity from "@/components/Icons/Action/Opacity";
import OpenInBrowser from "@/components/Icons/Action/OpenInBrowser";
import OpenInFull from "@/components/Icons/Action/OpenInFull";
import OpenInNew from "@/components/Icons/Action/OpenInNew";
import OpenWith from "@/components/Icons/Action/OpenWith";
import Outbond from "@/components/Icons/Action/Outbond";
import Outlet from "@/components/Icons/Action/Outlet";
import Pageview from "@/components/Icons/Action/Pageview";
import PanTool from "@/components/Icons/Action/PanTool";
import Payment from "@/components/Icons/Action/Payment";
import Pending from "@/components/Icons/Action/Pending";
import PendingActions from "@/components/Icons/Action/PendingActions";
import PermCameraMic from "@/components/Icons/Action/PermCameraMic";
import PermContactCalendar from "@/components/Icons/Action/PermContactCalendar";
import PermDataSetting from "@/components/Icons/Action/PermDataSetting";
import PermDeviceInformation from "@/components/Icons/Action/PermDeviceInformation";
import PermIdentity from "@/components/Icons/Action/PermIdentity";
import PermMedia from "@/components/Icons/Action/PermMedia";
import PermPhoneMsg from "@/components/Icons/Action/PermPhoneMsg";
import PermScanWifi from "@/components/Icons/Action/PermScanWifi";
import Pets from "@/components/Icons/Action/Pets";
import PictureInPicture from "@/components/Icons/Action/PictureInPicture";
import PictureInPictureAlt from "@/components/Icons/Action/PictureInPictureAlt";
import Plagiarism from "@/components/Icons/Action/Plagiarism";
import PlayForWork from "@/components/Icons/Action/PlayForWork";
import Polymer from "@/components/Icons/Action/Polymer";
import PowerSettingsNew from "@/components/Icons/Action/PowerSettingsNew";
import PregnantWoman from "@/components/Icons/Action/PregnantWoman";
import Preview from "@/components/Icons/Action/Preview";
import Print from "@/components/Icons/Action/Print";
import PrivacyTip from "@/components/Icons/Action/PrivacyTip";
import PublishedWithChanges from "@/components/Icons/Action/PublishedWithChanges";
import QueryBuilder from "@/components/Icons/Action/QueryBuilder";
import QuestionAnswer from "@/components/Icons/Action/QuestionAnswer";
import Quickreply from "@/components/Icons/Action/Quickreply";
import Receipt from "@/components/Icons/Action/Receipt";
import RecordVoiceOver from "@/components/Icons/Action/RecordVoiceOver";
import Redeem from "@/components/Icons/Action/Redeem";
import RemoveShoppingCart from "@/components/Icons/Action/RemoveShoppingCart";
import Reorder from "@/components/Icons/Action/Reorder";
import ReportProblem from "@/components/Icons/Action/ReportProblem";
import RequestPage from "@/components/Icons/Action/RequestPage";
import Restore from "@/components/Icons/Action/Restore";
import RestoreFromTrash from "@/components/Icons/Action/RestoreFromTrash";
import RestorePage from "@/components/Icons/Action/RestorePage";
import Room from "@/components/Icons/Action/Room";
import RoundedCorner from "@/components/Icons/Action/RoundedCorner";
import Rowing from "@/components/Icons/Action/Rowing";
import Rule from "@/components/Icons/Action/Rule";
import Schedule from "@/components/Icons/Action/Schedule";
import Search from "@/components/Icons/Action/Search";
import SearchOff from "@/components/Icons/Action/SearchOff";
import Settings from "@/components/Icons/Action/Settings";
import SettingsApplications from "@/components/Icons/Action/SettingsApplications";
import SettingsBackupRestore from "@/components/Icons/Action/SettingsBackupRestore";
import SettingsBluetooth from "@/components/Icons/Action/SettingsBluetooth";
import SettingsBrightness from "@/components/Icons/Action/SettingsBrightness";
import SettingsCell from "@/components/Icons/Action/SettingsCell";
import SettingsEthernet from "@/components/Icons/Action/SettingsEthernet";
import SettingsInputAntenna from "@/components/Icons/Action/SettingsInputAntenna";
import SettingsInputComponent from "@/components/Icons/Action/SettingsInputComponent";
import SettingsInputComposite from "@/components/Icons/Action/SettingsInputComposite";
import SettingsInputHdmi from "@/components/Icons/Action/SettingsInputHdmi";
import SettingsInputSvideo from "@/components/Icons/Action/SettingsInputSvideo";
import SettingsOverscan from "@/components/Icons/Action/SettingsOverscan";
import SettingsPhone from "@/components/Icons/Action/SettingsPhone";
import SettingsPower from "@/components/Icons/Action/SettingsPower";
import SettingsRemote from "@/components/Icons/Action/SettingsRemote";
import SettingsVoice from "@/components/Icons/Action/SettingsVoice";
import Shop from "@/components/Icons/Action/Shop";
import ShopTwo from "@/components/Icons/Action/ShopTwo";
import ShoppingBag from "@/components/Icons/Action/ShoppingBag";
import ShoppingBasket from "@/components/Icons/Action/ShoppingBasket";
import ShoppingCart from "@/components/Icons/Action/ShoppingCart";
import SmartButton from "@/components/Icons/Action/SmartButton";
import IcSource from "@/components/Icons/Action/IcSource";
import SpeakerNotes from "@/components/Icons/Action/SpeakerNotes";
import SpeakerNotesOff from "@/components/Icons/Action/SpeakerNotesOff";
import Spellcheck from "@/components/Icons/Action/Spellcheck";
import StarRate from "@/components/Icons/Action/StarRate";
import Stars from "@/components/Icons/Action/Stars";
import StickyNote2 from "@/components/Icons/Action/StickyNote2";
import Store from "@/components/Icons/Action/Store";
import Subject from "@/components/Icons/Action/Subject";
import SubtitlesOff from "@/components/Icons/Action/SubtitlesOff";
import SupervisedUserCircle from "@/components/Icons/Action/SupervisedUserCircle";
import SupervisorAccount from "@/components/Icons/Action/SupervisorAccount";
import Support from "@/components/Icons/Action/Support";
import SwapHoriz from "@/components/Icons/Action/SwapHoriz";
import SwapHorizontalCircle from "@/components/Icons/Action/SwapHorizontalCircle";
import SwapVert from "@/components/Icons/Action/SwapVert";
import SwapVerticalCircle from "@/components/Icons/Action/SwapVerticalCircle";
import SyncAlt from "@/components/Icons/Action/SyncAlt";
import SystemUpdateAlt from "@/components/Icons/Action/SystemUpdateAlt";
import Tab from "@/components/Icons/Action/Tab";
import TabUnselected from "@/components/Icons/Action/TabUnselected";
import TableView from "@/components/Icons/Action/TableView";
import TextRotateUp from "@/components/Icons/Action/TextRotateUp";
import TextRotateVertical from "@/components/Icons/Action/TextRotateVertical";
import TextRotationAngledown from "@/components/Icons/Action/TextRotationAngledown";
import TextRotationAngleup from "@/components/Icons/Action/TextRotationAngleup";
import TextRotationDown from "@/components/Icons/Action/TextRotationDown";
import TextRotationNone from "@/components/Icons/Action/TextRotationNone";
import Theaters from "@/components/Icons/Action/Theaters";
import ThumbDown from "@/components/Icons/Action/ThumbDown";
import ThumbUp from "@/components/Icons/Action/ThumbUp";
import ThumbsUpDown from "@/components/Icons/Action/ThumbsUpDown";
import Timeline from "@/components/Icons/Action/Timeline";
import Toc from "@/components/Icons/Action/Toc";
import Today from "@/components/Icons/Action/Today";
import Toll from "@/components/Icons/Action/Toll";
import TouchApp from "@/components/Icons/Action/TouchApp";
import Tour from "@/components/Icons/Action/Tour";
import TrackChanges from "@/components/Icons/Action/TrackChanges";
import Translate from "@/components/Icons/Action/Translate";
import TrendingDown from "@/components/Icons/Action/TrendingDown";
import TrendingFlat from "@/components/Icons/Action/TrendingFlat";
import TrendingUp from "@/components/Icons/Action/TrendingUp";
import TurnedIn from "@/components/Icons/Action/TurnedIn";
import TurnedInNot from "@/components/Icons/Action/TurnedInNot";
import Unpublished from "@/components/Icons/Action/Unpublished";
import Update from "@/components/Icons/Action/Update";
import Upgrade from "@/components/Icons/Action/Upgrade";
import Verified from "@/components/Icons/Action/Verified";
import VerifiedUser from "@/components/Icons/Action/VerifiedUser";
import VerticalSplit from "@/components/Icons/Action/VerticalSplit";
import ViewAgenda from "@/components/Icons/Action/ViewAgenda";
import ViewArray from "@/components/Icons/Action/ViewArray";
import ViewCarousel from "@/components/Icons/Action/ViewCarousel";
import ViewColumn from "@/components/Icons/Action/ViewColumn";
import ViewDay from "@/components/Icons/Action/ViewDay";
import ViewHeadline from "@/components/Icons/Action/ViewHeadline";
import ViewList from "@/components/Icons/Action/ViewList";
import ViewModule from "@/components/Icons/Action/ViewModule";
import ViewQuilt from "@/components/Icons/Action/ViewQuilt";
import ViewSidebar from "@/components/Icons/Action/ViewSidebar";
import ViewStream from "@/components/Icons/Action/ViewStream";
import ViewWeek from "@/components/Icons/Action/ViewWeek";
import Visibility from "@/components/Icons/Action/Visibility";
import VisibilityOff from "@/components/Icons/Action/VisibilityOff";
import VoiceOverOff from "@/components/Icons/Action/VoiceOverOff";
import WatchLater from "@/components/Icons/Action/WatchLater";
import WifiProtectedSetup from "@/components/Icons/Action/WifiProtectedSetup";
import Work from "@/components/Icons/Action/Work";
import WorkOff from "@/components/Icons/Action/WorkOff";
import WorkOutline from "@/components/Icons/Action/WorkOutline";
import Wysiwyg from "@/components/Icons/Action/Wysiwyg";
import YoutubeSearchedFor from "@/components/Icons/Action/YoutubeSearchedFor";
import ZoomIn from "@/components/Icons/Action/ZoomIn";
import ZoomOut from "@/components/Icons/Action/ZoomOut";
import HomeLinear from "@/components/Icons/Action/HomeLinear";
import Logout from "@/components/Icons/Action/Logout";
import HomeBold from "@/components/Icons/Action/HomeBold";

export default {
  components: {
    TridRotation,
    Accessibility,
    AccessibilityNew,
    Accessible,
    AccessibleForward,
    AccountBalance,
    AccountBalanceWallet,
    AccountBox,
    AccountCircle,
    AddShoppingCart,
    AddTask,
    Addchart,
    AdminPanelSettings,
    Alarm,
    AlarmAdd,
    AlarmOff,
    AlarmOn,
    AllInbox,
    AllOut,
    Analytics,
    Anchor,
    Android,
    Announcement,
    Api,
    AppBlocking,
    ArrowCircleDown,
    ArrowCircleUp,
    ArrowRightAlt,
    IcArticle,
    AspectRatio,
    Assessment,
    Assignment,
    AssignmentInd,
    AssignmentLate,
    AssignmentReturn,
    AssignmentReturned,
    AssignmentTurnedIn,
    Autorenew,
    Backup,
    BackupTable,
    BatchPrediction,
    Book,
    BookOnline,
    Bookmark,
    BookmarkBorder,
    Bookmarks,
    BugReport,
    Build,
    BuildCircle,
    Cached,
    CalendarToday,
    CalendarViewDay,
    CameraEnhance,
    CancelScheduleSend,
    CardGiftcard,
    CardMembership,
    CardTravel,
    ChangeHistory,
    CheckCircle,
    CheckCircleOutline,
    ChromeReaderMode,
    Class,
    CloseFullscreen,
    IcCode,
    CommentBank,
    Commute,
    CompareArrows,
    ContactPage,
    ContactSupport,
    Contactless,
    Copyright,
    CreditCard,
    Dashboard,
    DateRange,
    Delete,
    DeleteForever,
    DeleteOutline,
    Description,
    DisabledByDefault,
    Dns,
    Done,
    DoneAll,
    DoneOutline,
    DonutLarge,
    DonutSmall,
    DragIndicator,
    DynamicForm,
    Eco,
    Eject,
    EuroSymbol,
    Event,
    EventSeat,
    ExitToApp,
    Explore,
    ExploreOff,
    Extension,
    Face,
    FaceUnlock,
    FactCheck,
    Favorite,
    FavoriteBorder,
    Feedback,
    FilterAlt,
    FindInPage,
    FindReplace,
    Fingerprint,
    Flaky,
    FlightLand,
    FlightTakeoff,
    FlipToBack,
    FlipToFront,
    GTranslate,
    Gavel,
    GetApp,
    Gif,
    Grade,
    Grading,
    GroupWork,
    Help,
    HelpCenter,
    HelpOutline,
    HighlightAlt,
    HighlightOff,
    History,
    HistoryToggleOff,
    Home,
    HorizontalSplit,
    HourglassDisabled,
    HourglassEmpty,
    HourglassFull,
    Http,
    Https,
    ImportantDevices,
    Info,
    InfoOutline,
    IcInput,
    IntegrationInstructions,
    InvertColors,
    IcLabel,
    LabelImportant,
    LabelImportantOutline,
    LabelOff,
    LabelOutline,
    Language,
    Launch,
    Leaderboard,
    LightbulbOutline,
    LineStyle,
    LineWeight,
    List,
    Lock,
    LockOpen,
    LockOutline,
    Login,
    Loyalty,
    MarkunreadMailbox,
    Maximize,
    Mediation,
    Minimize,
    ModelTraining,
    NextPlan,
    NotAccessible,
    NotStarted,
    NoteAdd,
    OfflineBolt,
    OfflinePin,
    OnlinePrediction,
    Opacity,
    OpenInBrowser,
    OpenInFull,
    OpenInNew,
    OpenWith,
    Outbond,
    Outlet,
    Pageview,
    PanTool,
    Payment,
    Pending,
    PendingActions,
    PermCameraMic,
    PermContactCalendar,
    PermDataSetting,
    PermDeviceInformation,
    PermIdentity,
    PermMedia,
    PermPhoneMsg,
    PermScanWifi,
    Pets,
    PictureInPicture,
    PictureInPictureAlt,
    Plagiarism,
    PlayForWork,
    Polymer,
    PowerSettingsNew,
    PregnantWoman,
    Preview,
    Print,
    PrivacyTip,
    PublishedWithChanges,
    QueryBuilder,
    QuestionAnswer,
    Quickreply,
    Receipt,
    RecordVoiceOver,
    Redeem,
    RemoveShoppingCart,
    Reorder,
    ReportProblem,
    RequestPage,
    Restore,
    RestoreFromTrash,
    RestorePage,
    Room,
    RoundedCorner,
    Rowing,
    Rule,
    Schedule,
    Search,
    SearchOff,
    Settings,
    SettingsApplications,
    SettingsBackupRestore,
    SettingsBluetooth,
    SettingsBrightness,
    SettingsCell,
    SettingsEthernet,
    SettingsInputAntenna,
    SettingsInputComponent,
    SettingsInputComposite,
    SettingsInputHdmi,
    SettingsInputSvideo,
    SettingsOverscan,
    SettingsPhone,
    SettingsPower,
    SettingsRemote,
    SettingsVoice,
    Shop,
    ShopTwo,
    ShoppingBag,
    ShoppingBasket,
    ShoppingCart,
    SmartButton,
    IcSource,
    SpeakerNotes,
    SpeakerNotesOff,
    Spellcheck,
    StarRate,
    Stars,
    StickyNote2,
    Store,
    Subject,
    SubtitlesOff,
    SupervisedUserCircle,
    SupervisorAccount,
    Support,
    SwapHoriz,
    SwapHorizontalCircle,
    SwapVert,
    SwapVerticalCircle,
    SyncAlt,
    SystemUpdateAlt,
    Tab,
    TabUnselected,
    TableView,
    TextRotateUp,
    TextRotateVertical,
    TextRotationAngledown,
    TextRotationAngleup,
    TextRotationDown,
    TextRotationNone,
    Theaters,
    ThumbDown,
    ThumbUp,
    ThumbsUpDown,
    Timeline,
    Toc,
    Today,
    Toll,
    TouchApp,
    Tour,
    TrackChanges,
    Translate,
    TrendingDown,
    TrendingFlat,
    TrendingUp,
    TurnedIn,
    TurnedInNot,
    Unpublished,
    Update,
    Upgrade,
    Verified,
    VerifiedUser,
    VerticalSplit,
    ViewAgenda,
    ViewArray,
    ViewCarousel,
    ViewColumn,
    ViewDay,
    ViewHeadline,
    ViewList,
    ViewModule,
    ViewQuilt,
    ViewSidebar,
    ViewStream,
    ViewWeek,
    Visibility,
    VisibilityOff,
    VoiceOverOff,
    WatchLater,
    WifiProtectedSetup,
    Work,
    WorkOff,
    WorkOutline,
    Wysiwyg,
    YoutubeSearchedFor,
    ZoomIn,
    ZoomOut,
    HomeLinear,
    Logout,
    HomeBold
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
